import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getServices } from "../../libs/todoSlice"
import { useNavigate, useParams } from "react-router-dom"
import FadeIn from "react-fade-in/lib/FadeIn"
import { getStepRedux, setStepRedux } from "../../libs/eduPortalManagementSlice"
import EduPortalManagementTable from "./EduPortalManagement/TablePortal"
import EduPortalManagementCreatePortal from "./EduPortalManagement/CreatePortal"
import EduPortalManagementEditPortal from "./EduPortalManagement/EditPortal"

const EduPortalManagement = () => {
  const services = useSelector(getServices)
  const params = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const step = useSelector(getStepRedux)

  const setStep = (action) => {
    dispatch(setStepRedux({
      step: action
    }))
  }
  useEffect(() => {
    if (!services.includes('edu-portal-management')) {
      navigate(`/${params.prefix}/manage-members`)
    }
  })
  useEffect(() => {
    setStep('table')
  }, [])


  return (
    <FadeIn>
      {
        {
          "table": (
            <EduPortalManagementTable />
          ),
          "createPortal": (
            <EduPortalManagementCreatePortal />
          ),
          "editPortal": (
            <EduPortalManagementEditPortal />
          ),
        }[step]

      }
    </FadeIn>
  )
}

export default EduPortalManagement